"use client";

import T from "@marginly/ui/components/typography";

import { Noop } from "@/components/util";

import { formatUsd } from "../../../util/formatters";
import Space from "../../common/space";
import { EarnInfo, EarnInfoWrapper, EarnTitleBlock } from "./styled";

const plug = "-";
interface Props {
  chain: string;
  totalLiquidityUsd?: number;
  lenders?: number;
  traders?: number;
  volumeTodayUsd?: number;
}

const getTitle = (chain: string) => {
  switch (chain) {
    default:
      return "Earn";
  }
};
const getSubTitle = (chain: string) => {
  switch (chain) {
    default:
      return "By supplying liquidity.";
  }
};

export const EarnTitle = ({
  chain,
  lenders,
  totalLiquidityUsd,
  traders,
  volumeTodayUsd,
}: Props) => {
  return (
    <div>
      <EarnTitleBlock>
        <div>
          <T headerL>{getTitle(chain)}</T>
          <Space height={6} heightMobile={6} />
          <T body secondary>
            {getSubTitle(chain)}
          </T>
        </div>

        {totalLiquidityUsd || lenders || traders || volumeTodayUsd ? (
          <EarnInfoWrapper>
            <EarnInfo>
              {totalLiquidityUsd ? (
                <div>
                  <T caption secondary>
                    Total Liquidity
                  </T>
                  <T body>
                    {totalLiquidityUsd ? formatUsd(totalLiquidityUsd) : plug}
                  </T>
                </div>
              ) : (
                <></>
              )}
              {lenders ? (
                <div>
                  <T caption secondary>
                    Lenders
                  </T>
                  <T body>{lenders || plug}</T>
                </div>
              ) : (
                <></>
              )}
              {traders ? (
                <div>
                  <T caption secondary>
                    Traders
                  </T>
                  <T body>{traders || plug}</T>
                </div>
              ) : (
                <></>
              )}
              {volumeTodayUsd ? (
                <div>
                  <T caption secondary>
                    Volume today
                  </T>
                  <T body>
                    {volumeTodayUsd ? formatUsd(volumeTodayUsd) : plug}
                  </T>
                </div>
              ) : (
                <></>
              )}
            </EarnInfo>
          </EarnInfoWrapper>
        ) : (
          <Noop />
        )}
      </EarnTitleBlock>
    </div>
  );
};
